(() => {
  // Fail-safe: if config or modal isn't present, do nothing
  const cfgEl = document.getElementById('delivery-services-config');
  const modal = document.getElementById('delivery-setup-modal');
  if (!cfgEl || !modal) return;

  let cfg;
  try { cfg = JSON.parse(cfgEl.textContent || "{}"); } catch { return; }

  // Determine if modal should apply at all for this product
  const hasAnyService =
    Boolean(cfg.stairs_tier) ||
    Boolean(cfg.haul_tier) ||
    Boolean(cfg.wglove_tier) ||
    Boolean(cfg.panel_install) ||
    cfg.lp_conversion === true;

  if (!hasAnyService) return;

  // Service Variant IDs (from your export)
  const SERVICE_VARIANTS = {
    haul: {
      standard: 52242137776417,
      medium:   52242137186593,
      large:    52237668483361,
      xl:       52410016891169
    },
    stairs: {
      standard: 52247331864865,
      medium:   52247333011745,
      large:    52247334977825,
      xl:       52409985564961
    },
    wglove: {
      standard: 52410032554273,
      medium:   52410032718113,
      large:    52410033275169,
      xl:       52410034356513
    },
    panel: {
      fridge:     52247317053729,
      dishwasher: 52247318004001
    },
    lpcon: 52410039107873
  };

  // Elements
  const stairsSection = modal.querySelector('[data-delivery-section="stairs"]');
  const haulSection   = modal.querySelector('[data-delivery-section="haul"]');
  const wgloveSection = modal.querySelector('[data-delivery-section="wglove"]');
  const panelSection  = modal.querySelector('[data-delivery-section="panel"]');
  const lpconSection  = modal.querySelector('[data-delivery-section="lpcon"]');

  // Show/hide each card based on metafields
  if (stairsSection) stairsSection.hidden = !cfg.stairs_tier;
  if (haulSection)   haulSection.hidden   = !cfg.haul_tier;
  if (wgloveSection) wgloveSection.hidden = !cfg.wglove_tier;
  if (panelSection)  panelSection.hidden  = !cfg.panel_install;
  if (lpconSection)  lpconSection.hidden  = cfg.lp_conversion !== true;

  const stairsFlights = modal.querySelector('#deliveryStairsFlights');
  const stairsNote    = modal.querySelector('#deliveryStairsNote');
  const haulToggle    = modal.querySelector('#deliveryHaulAway');
  const wgloveToggle  = modal.querySelector('#deliveryWglove');
  const panelToggle   = modal.querySelector('#deliveryPanelInstall');
  const lpToggle      = modal.querySelector('#deliveryLpCon');
  const confirmBtn    = modal.querySelector('#deliveryConfirm');

  const openModal = () => { modal.hidden = false; document.documentElement.style.overflow = 'hidden'; };
  const closeModal = () => { modal.hidden = true; document.documentElement.style.overflow = ''; };

  modal.querySelectorAll('[data-delivery-close]').forEach(el => el.addEventListener('click', closeModal));

  if (stairsFlights && stairsNote) {
    stairsFlights.addEventListener('change', () => {
      stairsNote.hidden = stairsFlights.value !== "5";
    });
  }

  // State captured at click time (selected variant + qty)
  let pendingMainId = null;
  let pendingQuantity = 1;

  // CAPTURE click before Alpine handler runs
  document.addEventListener('click', (e) => {
    const btn = e.target.closest?.('[data-delivery-atc]');
    if (!btn) return;

    // Only intercept when this product has any eligible services
    if (!hasAnyService) return;

    // Stop Alpine's @click ($store.cart.add) from firing
    e.preventDefault();
    e.stopImmediatePropagation();

    // Read current variant + qty from the product form hidden inputs (Alpine keeps them updated)
    const form = btn.closest('form');
const idInput = form?.querySelector('input[name="id"]');
const qtyInput = form?.querySelector('input[name="quantity"]');

// Prefer the live DOM value, but fallback to attribute value
const rawId = idInput?.value || idInput?.getAttribute('value');
const rawQty = qtyInput?.value || qtyInput?.getAttribute('value');

const mainId = Number(rawId);
const mainQty = Number(rawQty || 1);

// If product has only the default variant, ALWAYS use the real Shopify variant id from Liquid
let resolvedId = Number.isFinite(mainId) ? mainId : null;

// If we intercepted before getMatchedVariant() runs, the id may still be the product id.
// In that case, force Shopify’s real default variant id from Liquid.
if (cfg.default_variant_id) {
  if (!resolvedId || (cfg.product_id && resolvedId === Number(cfg.product_id))) {
    resolvedId = Number(cfg.default_variant_id);
  }
}

pendingMainId = resolvedId;
    pendingQuantity = (Number.isFinite(mainQty) && mainQty > 0) ? mainQty : 1;
    if (stairsFlights) stairsFlights.value = "0";
    if (haulToggle) haulToggle.checked = false;
    if (wgloveToggle) wgloveToggle.checked = false;
    if (panelToggle) panelToggle.checked = false;
    if (lpToggle) lpToggle.checked = false;
    if (stairsNote) stairsNote.hidden = true;
    openModal();
  }, true);

  async function addItems(items) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items })
    });
    if (!res.ok) throw new Error(await res.text().catch(() => 'Add failed'));
    return res.json();
  }

  async function refreshAjaxCartSection() {
    const res = await fetch('/?sections=section-ajax-cart', { credentials: 'same-origin' });
    const sections = await res.json();
    const html = sections['section-ajax-cart'];
    if (!html) return;

    const doc = new DOMParser().parseFromString(html, 'text/html');
    const newBody = doc.querySelector('[data-cart-body]');
    const curBody = document.querySelector('[data-cart-body]');
    if (!newBody || !curBody) return;

    curBody.innerHTML = newBody.innerHTML;

    ['data-items-count','data-cart-total','data-cart-total-price'].forEach(attr => {
      const v = newBody.getAttribute(attr);
      if (v !== null) curBody.setAttribute(attr, v);
    });
  }

  function openCartDrawer() {
    document.querySelector('[data-cart-toggle]')?.click();
  }

    /**
   * MDA custom add-ons
   *
   * Reads any checked products from the custom MDA add-on block rendered by:
   * snippets/mda-addon-upsell.liquid
   *
   * Each checkbox contains the add-on product's default Shopify variant ID.
   * Shopify carts add variants, not products, so this variant ID is what we send
   * to /cart/add.js.
   */
  function getSelectedMdaAddonItems(quantity) {
    return Array.from(document.querySelectorAll('[data-mda-addon-checkbox]:checked'))
      .map((checkbox) => {
        const variantId = Number(checkbox.dataset.variantId);

        if (!variantId) return null;

        return {
          id: variantId,
          quantity: quantity
        };
      })
      .filter(Boolean);
  }

  confirmBtn?.addEventListener('click', async () => {
    try {
      confirmBtn.disabled = true;

      const applianceVariantId = Number(pendingMainId);
      if (!applianceVariantId) throw new Error('Missing appliance variant id');

            const items = [{
        id: applianceVariantId,
        quantity: pendingQuantity
      }];

      /**
       * Add selected MDA add-ons to the same cart request as the appliance.
       *
       * These are products selected from custom.mda_addons on the product page.
       * Quantity matches the appliance quantity, so buying 2 dishwashers adds
       * 2 of the selected compatible add-on.
       */
      const selectedMdaAddons = getSelectedMdaAddonItems(pendingQuantity);

      if (selectedMdaAddons.length) {
        items.push(...selectedMdaAddons);
      }

      // Stairs (qty = flights)
      if (cfg.stairs_tier && stairsFlights) {
        const flights = Number(stairsFlights.value || 0);
        if (flights > 0) {
          const tier = String(cfg.stairs_tier).toLowerCase();
          const sId = SERVICE_VARIANTS.stairs[tier];
          if (sId) {
            items.push({
              id: sId,
              quantity: flights * pendingQuantity,
              properties: {
                "Service": "Stairs Carry",
                "Flights": flights === 5 ? "5+ (charged as 5)" : String(flights),
                "Appliances": String(pendingQuantity),
                "Total stair carries": String(flights * pendingQuantity),
                "Applies to SKU": cfg.product_sku || ""
}
            });
          }
        }
      }

      // White Glove (tiered like haul-away)
      if (cfg.wglove_tier && wgloveToggle?.checked) {
        const tier = String(cfg.wglove_tier).toLowerCase();
        const wId = SERVICE_VARIANTS.wglove[tier];
        if (wId) {
          items.push({
            id: wId,
            quantity: pendingQuantity,
            properties: {
              "Service": "White Glove",
              "Applies to SKU": cfg.product_sku || ""
            }
          });
        }
      }

      // Haul-away
      if (cfg.haul_tier && haulToggle?.checked) {
        const tier = String(cfg.haul_tier).toLowerCase();
        const hId = SERVICE_VARIANTS.haul[tier];
        if (hId) {
          items.push({
            id: hId,
            quantity: pendingQuantity,
            properties: {
              "Service": "Haul Away",
              "Applies to SKU": cfg.product_sku || ""
            }
          });
        }
      }

      // Panel install (fridge/dishwasher)
      if (cfg.panel_install && panelToggle?.checked) {
        const key = String(cfg.panel_install).toLowerCase();
        const pId = SERVICE_VARIANTS.panel[key];
        if (pId) {
          items.push({
            id: pId,
            quantity: pendingQuantity,
            properties: {
              "Service": "Panel Installation",
              "Applies to SKU": cfg.product_sku || ""
            }
          });
        }
      }

      // LP conversion (boolean)
      if (cfg.lp_conversion === true && lpToggle?.checked) {
        items.push({
          id: SERVICE_VARIANTS.lpcon,
          quantity: pendingQuantity,
          properties: {
            "Service": "Liquid Propane Conversion",
            "Applies to SKU": cfg.product_sku || ""
          }
        });
      }
      await addItems(items);
      closeModal();
      await refreshAjaxCartSection();
      openCartDrawer();

    } catch (err) {
      console.error(err);
      alert("Something went wrong adding delivery services. Please try again.");
    } finally {
      if (confirmBtn) confirmBtn.disabled = false;
    }
  });
})();